import './index.scss';
import ApexCharts from 'apexcharts';
import ChartSummarySection from '../commons/chart-summary/index.js';

import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from 'moment';
import { __ } from '@wordpress/i18n';


class CourseCompletionRate extends Component {
  constructor(props) {
    super(props);
      let error=null;
      if(null==this.getUserType()) {
        error = {message:__('Sorry you are not allowed to access this block, please check if you have proper access permissions','learndash-reports-by-woocommerce')}
      }
      this.state = {
        isLoaded: false,
        error: error,
        reportTypeInUse: wisdm_learndash_reports_front_end_script_course_completion_rate.report_type,
        chart_title:__('Course Completion Rate', 'learndash-reports-by-wisdmlabs'),
        graph_type:'bar',
        lock_icon:'',
        series:[],
        options:[],
        graph_summary:[],
        start_date:moment(new Date(wisdm_ld_reports_common_script_data.start_date)).unix(),
        end_date:moment(new Date(wisdm_ld_reports_common_script_data.end_date)).unix(),          
        help_text:__('This report displays the percentage of learners who have completed each course, in comparison to the total number of learners enrolled in the course.','learndash-reports-by-wisdmlabs'),
      };

      if (false==wisdm_learndash_reports_front_end_script_course_completion_rate.is_pro_version_active) {
        this.upgdare_to_pro = 'wisdm-ld-reports-upgrade-to-pro-front';
        this.lock_icon = <span title={__('Please upgrade the plugin to access this feature', 'learndash-reports-by-wisdmlabs')} class="dashicons dashicons-lock ld-reports top-corner"></span>
      } 

      this.durationUpdated        = this.durationUpdated.bind(this);
      this.applyFilters           = this.applyFilters.bind(this);
      this.handleReportTypeChange = this.handleReportTypeChange.bind(this);
    }
  
    isValidGraphData() {
      if (undefined==this.state.options || 0==this.state.options.length) {
        return false;
      } 
      if (undefined==this.state.series || undefined==this.state.series[0]) {
        return false;
      }
      if (undefined==this.state.series[0].data || 0==this.state.series[0].data.length) {
        return false;
      }
      return true;
    }

    /**
     * Based on the current user roles aray this function desides wether a user is a group
     * leader or an Administrator and returns the same.
     */
    getUserType() {
      let userRoles = wisdm_learndash_reports_front_end_script_average_quiz_attempts.user_roles;
      if ('object'==typeof(userRoles)) {
        userRoles = Object.keys(userRoles).map((key) => userRoles[key]);
      }
      if (undefined==userRoles || userRoles.length==0) {
        return null;
      }
      if (userRoles.includes('administrator')) {
          return 'administrator';
      } else if (userRoles.includes('group_leader')) {
          return 'group_leader';
      }
      return null;
    }

    componentDidMount() {    
      this.updateChart('/rp/v1/course-completion-rate?start_date=' + this.state.start_date + '&&end_date=' + this.state.end_date);
      document.addEventListener('duration_updated', this.durationUpdated);
      document.addEventListener('wisdm-ld-reports-filters-applied', this.applyFilters);
      document.addEventListener('wisdm-ld-reports-report-type-selected', this.handleReportTypeChange);
    }

    componentDidUpdate() {
      jQuery('.CourseCompletionRate .mixed-chart').prepend(jQuery('.CourseCompletionRate .apexcharts-toolbar'));
      jQuery( ".wisdm-learndash-reports-course-completion-rate .chart-title .dashicons" ).hover(

        function() {
          var $div = jQuery('<div/>').addClass('wdm-tooltip').css({
              position: 'absolute',
              zIndex: 999,
              display: 'none'
          }).appendTo(jQuery(this));
          $div.text(jQuery(this).attr('data-title'));
          $div.show();
        }, function() {
          jQuery( this ).find( ".wdm-tooltip" ).remove();
        }
      );
    }

    handleReportTypeChange(event) {
        this.setState({reportTypeInUse:event.detail.active_reports_tab});
    }


    applyFilters(event) {
      let start_date = event.detail.start_date;
      let end_date   = event.detail.end_date;
      let category   = event.detail.selected_categories;
      let course     = event.detail.selected_courses;
      let lesson     = event.detail.selected_lessons;
      let topic      = event.detail.selected_topics;
      let learner    = event.detail.selected_learners;
   
      let request_url = '/rp/v1/course-completion-rate/?start_date=' + start_date + '&end_date=' + end_date + '&category=' + category + '&course=' + course + '&lesson=' + lesson + '&topic=' + topic + '&learner=' + learner;
   
      //Time spent on a course chart should not display for lesson/topic
    if (undefined==topic && undefined==lesson) {
      this.updateChart(request_url);
      this.setState({reportTypeInUse:'default-ld-reports'});
    } else {
        //hide this block.
        this.setState({reportTypeInUse:'default-ld-reports-lesson-topic'});
    }   
  }

    durationUpdated(event) {
      this.setState({isLoaded: false, start_date:event.detail.startDate, end_date:event.detail.endDate});
      let requestUrl = '/rp/v1/course-completion-rate/';
      if ('duration_updated'==event.type) {
        requestUrl = '/rp/v1/course-completion-rate/?start_date=' + event.detail.startDate + '&&end_date=' + event.detail.endDate;
      } 
      this.updateChart(requestUrl);
    }

    updateChart(requestUrl) {
      this.setState({isLoaded:false, error:null});
        wp.apiFetch({
          path: requestUrl //Replace with the correct API
       }).then(response => {
          this.plotChartTypeBy(response);
          }).catch((error) => {
            this.setState({
              error:error,
              graph_summary:[],
              series:[],
              isLoaded: true,
            });
          });
      }

      plotChartTypeBy(response) {
        if (undefined!=response.courseWiseCompletion) {
          const completion = Object.values( response.courseWiseCompletion ).map( obj => obj.completion );
          const courses    = Object.values( response.courseWiseCompletion ).map( obj => obj.title );
          this.plotBarChart(courses, completion, __('Courses', 'learndash-reports-by-wisdmlabs'), __('Percentage of Learners - Completed', 'learndash-reports-by-wisdmlabs'));
          let avgTimeSpent = response.averageCourseCompletion;
          let lock_icon = '';
          if (true!=wisdm_learndash_reports_front_end_script_course_completion_rate.is_pro_version_active) {
            avgTimeSpent = '??';
            lock_icon = <span title={__('Please upgrade the plugin to access this feature', 'learndash-reports-by-wisdmlabs')} class="dashicons dashicons-lock ld-reports top-corner"></span>
          }
          this.setState(
            {
            isLoaded: true,
            lock_icon:lock_icon,
            graph_summary: {
              left: [{
                    title : __('AVERAGE COURSE COMPLETION RATE', 'learndash-reports-by-wisdmlabs'),
                    value: '??'!=avgTimeSpent?Number(parseFloat(avgTimeSpent).toFixed(2)) + '%':avgTimeSpent,
                  },],
  
              right:[{
                  title : __('Courses Completed By : ', 'learndash-reports-by-wisdmlabs'),
                  value : response.completedCount  + __(' Learners', 'learndash-reports-by-wisdmlabs'),
                }, 
                {
                  title: __('Courses Not Started By : ', 'learndash-reports-by-wisdmlabs'),
                  value:response.notstartedCount + __(' Learners', 'learndash-reports-by-wisdmlabs') ,
                },
                {
                  title: __('Courses In Progress By : ', 'learndash-reports-by-wisdmlabs'),
                  value:response.inprogressCount  + __(' Learners', 'learndash-reports-by-wisdmlabs') ,
                }],
                
            },
          }); 
        } else if(undefined!=response.progress_data) {
          let user_names = Object.values( response.progress_data ).map( obj => obj.user_name );
          let progress  = Object.values( response.progress_data ).map( obj => obj.progress );
          this.plotBarChart(user_names, progress, __('Learners', 'learndash-reports-by-wisdmlabs'), __('Rate of Completion', 'learndash-reports-by-wisdmlabs'));          
          let avgTimeSpent = response.averageCourseCompletion;
          let lock_icon = '';
          if (true!=wisdm_learndash_reports_front_end_script_course_completion_rate.is_pro_version_active) {
            avgTimeSpent = '??';
          }
          this.setState(
            {
            isLoaded: true,
            lock_icon:lock_icon,
            graph_summary: {
              left: [{
                    title : __('AVERAGE COURSE COMPLETION RATE', 'learndash-reports-by-wisdmlabs'),
                    value: '??'!=avgTimeSpent?Number(parseFloat(avgTimeSpent).toFixed(2)) + '%':avgTimeSpent,
                  },],
  
              right:[{
                  title : __('Courses Completed By : ', 'learndash-reports-by-wisdmlabs'),
                  value : response.completedCount  + __(' Learners', 'learndash-reports-by-wisdmlabs'),
                }, 
                {
                  title: __('Courses Not Started By : ', 'learndash-reports-by-wisdmlabs'),
                  value:response.notstartedCount + __(' Learners', 'learndash-reports-by-wisdmlabs') ,
                },
                {
                  title: __('Courses In Progress By : ', 'learndash-reports-by-wisdmlabs'),
                  value:response.inprogressCount  + __(' Learners', 'learndash-reports-by-wisdmlabs') ,
                }],
            },
          }); 
        } else if(undefined!=response.progress_data_new) {
          let user_names = Object.values( response.progress_data_new ).map( obj => obj.user_name );
          let progress  = Object.values( response.progress_data_new ).map( obj => obj.progress );
          this.plotBarChart(user_names, progress, __('Learners', 'learndash-reports-by-wisdmlabs'), __('Rate of Completion', 'learndash-reports-by-wisdmlabs'));          
          let avgTimeSpent = response.averageCourseCompletion;
          let lock_icon = '';
          if (true!=wisdm_learndash_reports_front_end_script_course_completion_rate.is_pro_version_active) {
            avgTimeSpent = '??';
          }
          this.setState(
            {
            isLoaded: true,
            lock_icon:lock_icon,
            graph_summary: {
              left: [{
                    title : __('AVERAGE COURSE COMPLETION RATE', 'learndash-reports-by-wisdmlabs'),
                    value: '??'!=avgTimeSpent?Number(parseFloat(avgTimeSpent).toFixed(2)) + '%':avgTimeSpent,
                  },],
  
              right:[{
                  title : __('Courses Completed : ', 'learndash-reports-by-wisdmlabs'),
                  value : response.completedCount  + __(' Courses', 'learndash-reports-by-wisdmlabs'),
                }, 
                {
                  title: __('Courses Not Started : ', 'learndash-reports-by-wisdmlabs'),
                  value:response.notstartedCount + __(' Courses', 'learndash-reports-by-wisdmlabs') ,
                },
                {
                  title: __('Courses In Progress : ', 'learndash-reports-by-wisdmlabs'),
                  value:response.inprogressCount  + __(' Courses', 'learndash-reports-by-wisdmlabs') ,
                }],
            },
          }); 
        }
      }

      plotBarChart(dataX, dataY, nameX, nameY) {
        let chart_options = {
          chart: {
            type: 'bar',
            width: dataX.length*75 < 645 ? '100%' : dataX.length*75,
            height: 400,
            zoom:{
              enabled:false,
            },
            toolbar:{
              show:true,
              export: {
                csv: {
                  filename: __( 'Completion Status.csv', 'learndash-reports-by-wisdmlabs' ),
                  columnDelimiter: ',',
                  headerCategory: nameX,
                  headerValue: nameY,
                },
                svg: {
                  filename: undefined,
                },
                png: {
                  filename: undefined,
                }
              },
            }
          },
          fill: {
            colors: [function({ value, seriesIndex, w }) {
              return '#444444'
            }],
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              width: '80px',
              columnWidth: '30%',
              dataLabels: {
                position: 'top', // top, center, bottom
              },
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val + "%";
            },
            offsetY: -25,
            style: {
              fontSize: '12px',
              colors: ["#304758"]
            }
          },

          itemMargin: {
              horizontal: 75,
              vertical: 100
          },
          
          xaxis: {
            title: {
              text: nameX,
            },
            categories: dataX,
            labels:{
                  hideOverlappingLabels: false,
                  trim: true,
              },
            itemMargin: {
                horizontal: 75,
                vertical: 100
            },
            tickPlacement: 'on',
            min: 1,
            // max:dataX.length>7?7:dataX.length,
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            
            
          },
          yaxis: {
            max: Math.max.apply(Math, dataY) + Math.max.apply(Math, dataY)/10,
            title:{
              text:nameY,
            },
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function (val) {
                return val + "%";
              },
              min: 0,
              max: 100,
            }
          
          },
        }
    
        this.setState({graph_type:'bar', series:[{name:nameY, data:dataY}], options:chart_options});
      }

  render() {
    let body = <div></div>;
    let data_validation = '';
    if (!this.isValidGraphData()) {
      data_validation = 'invalid-or-empty-data';
    }
    if(''!=this.state.reportTypeInUse && 'default-ld-reports'!=this.state.reportTypeInUse) {
      body = '';
    } else if (!this.state.isLoaded) {
      // yet loading
      body =  <div class="wisdm-learndash-reports-chart-block wisdm-ld-loading">
                <div>{__('Loading...', 'learndash-reports-by-wisdmlabs')}</div>
              </div>
  } else {
    let graph = '';
    if (!this.state.error) {
      graph = <div className="CourseCompletionRate">
                <div className="row">
                  <div className="mixed-chart">
                    <div className="ldr-toolbar">
                    </div>
                    <Chart
                      options={this.state.options}
                      series={this.state.series}
                      type={this.state.graph_type}
                      width={this.state.options.chart.width}
                      height={this.state.options.chart.height}
                    />
                  </div>
                </div>
              </div>;
    }
    body = 
    <div class={"wisdm-learndash-reports-chart-block " + data_validation}>
    <div class="wisdm-learndash-reports-course-completion-rate graph-card-container">
    <div class="chart-header course-completion-rate-chart-header">
        <div class="chart-title">
          <span>{this.state.chart_title}</span>
          <span class="dashicons dashicons-info-outline widm-ld-reports-info" data-title={this.state.help_text}></span>
        </div>
        <ChartSummarySection pro_upgrade_option={this.upgdare_to_pro} wrapper_class='chart-summary-course-completion-rate' graph_summary={this.state.graph_summary} error={this.state.error}/>
      </div>
      <div>
        {graph}
      </div>
    </div>
  </div>;
  }
    return (body);
  }
}


document.addEventListener("DOMContentLoaded", function(event) {
  
  let elem = document.getElementsByClassName('wisdm-learndash-reports-course-completion-rate front');
    if (elem.length>0) {
      ReactDOM.render(React.createElement(CourseCompletionRate), elem[0]); 
    }
    
});

jQuery(window).load(function(){
  jQuery('.CourseCompletionRate .mixed-chart').prepend(jQuery('.CourseCompletionRate .apexcharts-toolbar'));
})

